import { render, staticRenderFns } from "./commodity-data-card.vue?vue&type=template&id=78e6f509&scoped=true"
import script from "./commodity-data-card.vue?vue&type=script&lang=js"
export * from "./commodity-data-card.vue?vue&type=script&lang=js"
import style0 from "./commodity-data-card.vue?vue&type=style&index=0&id=78e6f509&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6f509",
  null
  
)

export default component.exports